<template>
  <svg width="100%" height="100%" viewBox="0 0 230 30" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g id="esp-text" transform="matrix(0.266667,0,0,0.266667,130.333,15)">
      <g transform="matrix(1,0,0,1,-370,-45)">
        <g transform="matrix(1.20335,0,0,1.20335,-351.004,-316.074)">
          <g
            id="esp-text-secondary"
            transform="matrix(0.831015,0,0,0.831015,291.69,262.662)"
          >
            <g transform="matrix(99.8453,0,0,99.8453,155.833,79.8863)">
              <path
                d="M0.773,-0.409C0.773,-0.269 0.673,-0.169 0.533,-0.169L0.252,-0.169L0.252,-0.299L0.533,-0.299C0.553,-0.299 0.643,-0.299 0.643,-0.409L0.643,-0.46C0.643,-0.57 0.553,-0.57 0.533,-0.57L0.232,-0.57C0.224,-0.57 0.217,-0.567 0.211,-0.561C0.205,-0.555 0.202,-0.548 0.202,-0.54L0.202,0.001L0.072,0.001L0.072,-0.52C0.072,-0.62 0.142,-0.7 0.252,-0.7L0.533,-0.7C0.683,-0.7 0.773,-0.61 0.773,-0.46L0.773,-0.409Z"
                style="fill-rule:nonzero;"
                :style="{ fill: secondary }"
              />
            </g>
            <g transform="matrix(99.8453,0,0,99.8453,235.31,79.8863)">
              <path
                d="M0.778,-0.47C0.778,-0.299 0.638,-0.229 0.538,-0.229L0.808,0.001L0.608,0.001L0.347,-0.229L0.257,-0.229L0.257,-0.359L0.538,-0.359C0.608,-0.359 0.648,-0.399 0.648,-0.47L0.648,-0.55C0.648,-0.561 0.639,-0.57 0.628,-0.57L0.207,-0.57L0.207,0.001L0.077,0.001L0.077,-0.64C0.077,-0.656 0.083,-0.671 0.095,-0.682C0.106,-0.694 0.121,-0.7 0.137,-0.7L0.618,-0.7C0.728,-0.7 0.778,-0.61 0.778,-0.55L0.778,-0.47Z"
                style="fill-rule:nonzero;"
                :style="{ fill: secondary }"
              />
            </g>
            <g transform="matrix(99.8453,0,0,99.8453,317.897,79.9112)">
              <path
                d="M0.812,-0.28C0.812,-0.119 0.682,0.001 0.522,0.001L0.342,0.001C0.181,0.001 0.051,-0.119 0.051,-0.28L0.051,-0.42C0.051,-0.55 0.151,-0.7 0.342,-0.7L0.522,-0.7C0.712,-0.7 0.812,-0.55 0.812,-0.42L0.812,-0.28ZM0.682,-0.42C0.682,-0.51 0.622,-0.57 0.522,-0.57L0.342,-0.57C0.241,-0.57 0.181,-0.52 0.181,-0.42L0.181,-0.28C0.181,-0.179 0.241,-0.129 0.342,-0.129L0.522,-0.129C0.612,-0.129 0.682,-0.179 0.682,-0.28L0.682,-0.42Z"
                style="fill-rule:nonzero;"
                :style="{ fill: secondary }"
              />
            </g>
            <g transform="matrix(1.20335,0,0,1.20335,-354.004,-316.074)">
              <g
                transform="matrix(6.12323e-17,1,-1,6.12323e-17,1138.79,164.693)"
              >
                <path
                  d="M130.379,488.933C130.379,489.393 130.751,489.766 131.211,489.766C133.097,489.766 137.679,489.766 139.542,489.766C139.989,489.766 140.351,489.404 140.351,488.957C140.351,484.801 140.351,465.918 140.351,462.784C140.351,462.491 140.304,462.201 140.211,461.923C140.195,461.874 140.178,461.822 140.159,461.767C139.755,460.555 138.82,459.595 137.62,459.158C134.942,458.184 130.379,456.525 130.379,456.525L130.379,488.933Z"
                  style="fill-rule:nonzero;"
                  :style="{ fill: secondary }"
                />
              </g>
              <g transform="matrix(82.973,0,0,82.973,628.083,329.049)">
                <path
                  d="M0.713,-0.57L0.202,-0.57L0.202,0.001L0.072,0.001L0.072,-0.629C0.072,-0.668 0.104,-0.7 0.143,-0.7L0.713,-0.7L0.713,-0.57Z"
                  style="fill-rule:nonzero;"
                  :style="{ fill: secondary }"
                />
              </g>
            </g>
            <g transform="matrix(99.8453,0,0,99.8453,475.513,79.8977)">
              <path
                d="M0.205,0.001L0.075,0.001L0.075,-0.7L0.205,-0.7L0.205,0.001Z"
                style="fill-rule:nonzero;"
                :style="{ fill: secondary }"
              />
            </g>
            <g transform="matrix(99.8453,0,0,99.8453,499.107,79.8613)">
              <path
                d="M0.72,0.001L0.139,0.001C0.121,0.001 0.103,-0.006 0.09,-0.019C0.076,-0.032 0.069,-0.05 0.069,-0.069L0.069,-0.7L0.199,-0.7L0.199,-0.129L0.72,-0.129L0.72,0.001Z"
                style="fill-rule:nonzero;"
                :style="{ fill: secondary }"
              />
            </g>
            <g transform="matrix(1.20335,0,0,1.20335,-351.004,-316.074)">
              <g transform="matrix(82.973,0,0,82.973,768.969,329.049)">
                <path
                  d="M0.708,0.001L0.247,0.001C0.147,0.001 0.067,-0.08 0.067,-0.179L0.067,-0.64C0.067,-0.673 0.094,-0.7 0.127,-0.7L0.708,-0.7L0.708,-0.57L0.197,-0.57L0.197,-0.179C0.197,-0.166 0.202,-0.153 0.212,-0.144C0.221,-0.134 0.234,-0.129 0.247,-0.129L0.708,-0.129L0.708,0.001Z"
                  style="fill-rule:nonzero;"
                  :style="{ fill: secondary }"
                />
              </g>
              <g
                transform="matrix(6.12323e-17,1,-1,6.12323e-17,1279.23,164.672)"
              >
                <path
                  d="M130.379,488.933C130.379,489.393 130.751,489.766 131.211,489.766C133.097,489.766 137.679,489.766 139.542,489.766C139.989,489.766 140.351,489.404 140.351,488.957C140.351,485.388 140.351,470.961 140.351,464.97C140.351,463.229 140.07,461.5 139.52,459.849C140.351,462.342 140.27,462.1 140.159,461.767C139.755,460.555 138.82,459.595 137.62,459.158C134.942,458.184 130.379,456.525 130.379,456.525L130.379,488.933Z"
                  style="fill-rule:nonzero"
                  :style="{ fill: secondary }"
                />
              </g>
            </g>
            <g transform="matrix(99.8453,0,0,99.8453,647.753,79.9091)">
              <path
                d="M0.774,-0.46C0.774,-0.332 0.671,-0.229 0.544,-0.229L0.533,-0.229L0.804,0.001L0.613,0.001L0.343,-0.229L0.253,-0.229L0.253,-0.36L0.533,-0.36C0.563,-0.36 0.591,-0.371 0.611,-0.392C0.632,-0.413 0.643,-0.441 0.643,-0.47L0.643,-0.55C0.643,-0.561 0.635,-0.57 0.623,-0.57L0.203,-0.57L0.203,0.001L0.073,0.001L0.073,-0.64C0.073,-0.656 0.079,-0.671 0.09,-0.683C0.102,-0.694 0.117,-0.7 0.133,-0.7C0.241,-0.7 0.47,-0.7 0.623,-0.7C0.706,-0.7 0.774,-0.633 0.774,-0.55L0.774,-0.46Z"
                style="fill-rule:nonzero;"
                :style="{ fill: secondary }"
              />
            </g>
          </g>
          <g id="esp-text-primary">
            <g transform="matrix(82.973,0,0,82.973,356.598,329.049)">
              <path
                d="M0.75,-0.199C0.75,0.001 0.54,0.001 0.54,0.001L0.049,0.001L0.049,-0.129L0.54,-0.129C0.54,-0.129 0.62,-0.129 0.62,-0.199C0.62,-0.279 0.54,-0.279 0.54,-0.279L0.249,-0.279C0.229,-0.279 0.049,-0.279 0.049,-0.49C0.049,-0.7 0.239,-0.7 0.239,-0.7L0.68,-0.7L0.68,-0.57L0.249,-0.57C0.249,-0.57 0.179,-0.57 0.179,-0.49C0.179,-0.409 0.249,-0.409 0.249,-0.409L0.54,-0.409C0.54,-0.409 0.75,-0.409 0.75,-0.199Z"
                style="fill-rule:nonzero;"
                :style="{ fill: primary }"
              />
            </g>
            <g transform="matrix(1,0,0,1,89.2429,0)">
              <g
                transform="matrix(6.12323e-17,1,-1,6.12323e-17,715.481,164.693)"
              >
                <path
                  d="M130.379,488.933C130.379,489.393 130.751,489.766 131.211,489.766C133.097,489.766 137.679,489.766 139.542,489.766C139.989,489.766 140.351,489.404 140.351,488.957C140.351,484.801 140.351,465.918 140.351,462.784C140.351,462.491 140.304,462.201 140.211,461.923C140.195,461.874 140.178,461.822 140.159,461.767C139.755,460.555 138.82,459.595 137.62,459.158C134.942,458.184 130.379,456.525 130.379,456.525L130.379,488.933Z"
                  style="fill-rule:nonzero;"
                  :style="{ fill: primary }"
                />
              </g>
              <g transform="matrix(82.973,0,0,82.973,204.883,329.067)">
                <path
                  d="M0.702,0.001L0.241,0.001C0.196,0.001 0.153,-0.017 0.121,-0.049C0.089,-0.081 0.071,-0.124 0.071,-0.169L0.071,-0.64C0.071,-0.656 0.077,-0.671 0.088,-0.683C0.1,-0.694 0.115,-0.7 0.131,-0.7L0.702,-0.7L0.702,-0.57L0.201,-0.57L0.201,-0.159C0.201,-0.151 0.204,-0.144 0.21,-0.138C0.215,-0.132 0.223,-0.129 0.231,-0.129L0.702,-0.129L0.702,0.001Z"
                  style="fill-rule:nonzero;"
                  :style="{ fill: primary }"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="esp-icon" transform="matrix(0.107692,0,0,0.107692,15,15)">
      <g transform="matrix(1,0,0,1,-130,-130)">
        <g transform="matrix(-2.11667,0,0,2.11667,553.332,-505.233)">
          <g
            id="esp-icon-primary"
            transform="matrix(1.45311,0,0,1.45193,-21.1367,-162.739)"
          >
            <path
              d="M191.035,316.342C192.381,317.689 192.381,319.873 191.035,321.221C183.276,328.985 159.659,352.622 159.659,352.622L159.659,342.209C159.659,342.209 177.671,324.183 182.095,319.755C182.632,319.217 182.632,318.346 182.095,317.808C176.986,312.694 153.482,289.171 153.482,289.171L153.482,278.759C153.482,278.759 182.357,307.658 191.035,316.342Z"
              style="fill-rule:nonzero;"
              :style="{ fill: primary }"
            />
          </g>
          <g id="esp-icon-secondary" transform="matrix(1,0,0,1,0,-210)">
            <path
              d="M198.11,467.118C198.11,467.118 164.649,500.579 156.766,508.461C155.856,509.372 155.856,510.849 156.766,511.759C164.042,519.035 192.913,547.906 192.913,547.906L192.913,528.063L199.999,535.15C199.999,535.15 221.652,513.497 224.687,510.462C224.881,510.268 224.881,509.953 224.687,509.759C221.652,506.724 199.999,485.071 199.999,485.071C199.999,485.071 178.286,506.784 175.299,509.771C175.209,509.861 175.159,509.983 175.159,510.11C175.159,510.237 175.209,510.359 175.299,510.449C177.452,512.603 189.133,524.283 189.133,524.283L189.133,537.039C189.133,537.039 167.495,515.401 163.011,510.917C162.565,510.471 162.562,509.747 163.006,509.298C168.47,503.766 199.999,471.843 199.999,471.843C199.999,471.843 232.638,503.694 238.361,509.279C238.585,509.498 238.712,509.798 238.712,510.111C238.713,510.425 238.588,510.725 238.365,510.945C233.285,515.95 207.086,541.764 207.086,541.764L207.086,563.024L199.999,570.11C199.999,570.11 156.412,526.523 143.538,513.649C141.584,511.695 141.584,508.526 143.538,506.571C156.145,493.965 198.11,452 198.11,452L198.11,467.118Z"
              style="fill-rule:nonzero;"
              :style="{ fill: secondary }"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BrandLogo',

  props: {
    primary: {
      type: String,
      default: 'rgb(214,0,0)'
    },

    secondary: {
      type: String,
      default: 'rgba(255,255,255)'
    }
  }
}
</script>
